import {
    GETMERCHANTWIRELIST_SUCCESS,
    GETMERCHANTWIRELIST_FAILED,
    RESET_GETMERCHANTWIRELIST,
    LOADING_GETMERCHANTWIRELIST,
    NETWORK_ERROR_GETMERCHANTWIRELIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETMERCHANTWIRELIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GETMERCHANTWIRELIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GETMERCHANTWIRELIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GETMERCHANTWIRELIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GETMERCHANTWIRELIST:
            return (state = initialState);
        default:
            return state;
    }
};
